<template>
    <trax-ui-simple-table header="0" :rows="rows" :cols="cols" vertical-align="top">
    </trax-ui-simple-table>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
        },

        data: function() {
            return {
                lang: lang,
                status_names: data.status_names,
                status_colors: data.status_colors,
                rows: [],
                cols: [
                    {class: 'text-center', width: '150px'},
                    {},
                ],
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
        },

        methods: {

            setData(data) {
                this.rows = [];

                // Request
                this.addHistoryItemWithStatus(data, 'author', 'draft', 'launched_procedure', null, true);
                this.addHistoryItemWithStatus(data, 'atp_launch_submit', 'posted', 'posted_request');
                this.addHistoryItem(data, 'atp_launch_learner_validation', 'learner_acknowledged', this.lang.polaris.procedure.learner);

                // Proposal
                this.addHistoryItemWithStatus(data, 'atp_proposal_validation', 'submitted', 'submitted_proposal', 'HT');

                // OP validation
                this.addHistoryItem(data, 'op_rp_validation', 'responded_proposal', 'HT');
                this.addHistoryItem(data, 'op_gp_pdc_validation', 'responded_proposal', 'PC');
                this.addHistoryItem(data, 'op_cop_validation', 'responded_proposal', 'COP/GP');
                this.addHistoryItem(data, 'op_cmm_validation', 'responded_proposal', 'CMM');
                this.addHistoryItem(data, 'op_client_validation', 'validated_proposal', this.lang.polaris.procedure.client);
                this.addHistoryItem(data, 'op_client_rejection', 'rejected_proposal', this.lang.polaris.procedure.client);
                this.addHistoryItemWithStatus(data, 'op_final_validation', 'validated', 'validated_proposal', 'OP');
                this.addHistoryItemWithStatus(data, 'op_final_close', 'closed', 'closed_procedure');

                // Result
                this.addHistoryItemWithStatus(data, 'atp_result_validation', 'closed', 'closed_procedure');
            },

            addHistoryItemWithStatus(data, prop, status, short, badge, noCheck) {
                if (!noCheck && !data.data[prop]) return;
                this.rows.push([
                    this.dateStatusHtml(data.data[prop], status),
                    this.userHtml(data.data[prop], short, badge),
                ]);
            },

            addHistoryItem(data, prop, short, badge) {
                if (data.data[prop]) {
                    this.rows.push([
                        this.dateHtml(data.data[prop]),
                        this.userHtml(data.data[prop], short, badge),
                    ]);
                }
            },

            dateStatusHtml(author, code) {
                var label = this.status_names[code];
                var color = this.status_colors[code];
                return this.dateBadgeHtml(author, label, color)+'<br>'+this.dateHtml(author);
            },

            dateBadgeHtml(author, label, color) {
                return '<span class="badge badge-'+color+'">'+label+'</span>';
            },

            dateHtml(author) {
                var html = '';
                html += '<small>' + moment(author.date).format('DD MMM YYYY') + '</small>';
                return html;
            },

            userHtml(author, short, badge) {
                var html = '';
                html += '<span class="font-weight-bold">' + author.user_name + '</span>';
                if (badge) html += ' <span class="badge badge-default ml-2">'+badge+'</span> ';
                if (short) html += '<br><small>'+lang.polaris.procedure[short]+'</small>';
                if (author.comments) html += '<p class="pt-2" style="white-space:pre-wrap;">'+author.comments+'</p>';
                return html;
            }
        }
    }
</script>
